export const permissionConstants = {
    GOD_MODE: 'Velappity.GodMode', //TODO: Remove this!
    ISSUE:{
        VIEW: 'Issues.View',
        CREATE: 'Issues.Create',
        DELETE: 'Issues.Delete'
    }
}